import React from "react";
import { NavLink } from "react-router-dom";
export default class Navigation extends React.Component {
  handleLogout = () => {
    alert("adas");
    localStorage.removeItem("id_token");
    localStorage.removeItem("access_token");
    window.location.href = "http://cms-campaign.narendramodi.in";
  };
  render() {
    return (
      <nav className="navbar-default navbar-static-side" role="navigation">
        <div className="sidebar-collapse">
          <ul className="nav metismenu" id="side-menu">
            <li className="nav-header">
              <div className="dropdown profile-element">
                {" "}
                <span>
                  <img
                    alt="image"
                    className="img-circle"
                    src="/img/profile_small.jpg"
                  />
                </span>
                <a data-toggle="dropdown" className="dropdown-toggle" href="#">
                  <span className="clear">
                    {" "}
                    <span className="block m-t-xs">
                      {" "}
                      <strong className="font-bold">David Williams</strong>
                    </span>{" "}
                    <span className="text-muted text-xs block">
                      Art Director <b className="caret"></b>
                    </span>{" "}
                  </span>{" "}
                </a>
                <ul className="dropdown-menu animated fadeInRight m-t-xs">
                  <li>
                    <a href="profile.html">Profile</a>
                  </li>
                  <li>
                    <a href="contacts.html">Contacts</a>
                  </li>
                  <li>
                    <a href="mailbox.html">Mailbox</a>
                  </li>
                  <li className="divider"></li>
                  <li>
                    <a href="javascript:void(0)" onClick={this.handleLogout}>
                      Logout
                    </a>
                  </li>
                </ul>
              </div>
              <div className="logo-element">IN+</div>
            </li>
            <li
              className={
                window.location.href.indexOf("swachhteerth") != -1
                  ? "active"
                  : ""
              }
            >
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Indian Diaspora</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li
                  className={
                    window.location.href.indexOf(
                      "indiandiaspora/moderation"
                    ) != -1
                      ? "active"
                      : ""
                  }
                >
                  <NavLink to="/indiandiaspora/moderation">
                    Moderation
                  </NavLink>
                </li>
              </ul>
            </li>

            <li
              className={
                window.location.href.indexOf("swachhteerth") != -1
                  ? "active"
                  : ""
              }
            >
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Mei Hu Modi Parivar</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li
                  className={
                    window.location.href.indexOf(
                      "meihumodiparivar/moderation"
                    ) != -1
                      ? "active"
                      : ""
                  }
                >
                  <NavLink to="/meihumodiparivar/moderation">
                    Moderation
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Exam Warrior Yuva</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/examyuva/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li> */}
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">MKB 100</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/mkb100/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li>
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Vocal for Local</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/vocalforlocal/moderation">Moderation</NavLink>
                </li>
                <li>
                  <NavLink to="/vocalforlocal/dashboard">Dashboard</NavLink>
                </li>
                {/* <li>
                  <NavLink to="/vocalforlocal/uploadlist">Upload List</NavLink>
                </li> */}
                <li>
                  <NavLink to="/vocalforlocal/upload">Upload</NavLink>
                </li>
              </ul>
            </li>
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Viksit Bharat Selfie</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/viksitbharatselfie/moderation">
                    Moderation
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Viksit Bharat</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/viksitbharat/dashboard">Dashboard</NavLink>
                </li>
                <li>
                  <NavLink to="/viksitbharat/userdashboard">
                    User Dashboard
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink to="/viksitbharatuser/vbadashboard">
                    VBA User Dashboard
                  </NavLink>
                </li> */}
              </ul>
            </li>
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">VB Activity</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/vbactivity/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li>
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Modi Rally</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/modirally/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li>
            <li
              className={
                window.location.href.indexOf("swachhteerth") != -1
                  ? "active"
                  : ""
              }
            >
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Swachh Teerth</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li
                  className={
                    window.location.href.indexOf("swachhteerth/moderation") !=
                    -1
                      ? "active"
                      : ""
                  }
                >
                  <NavLink to="/swachhteerth/moderation">Moderation</NavLink>
                </li>
                <li
                  className={
                    window.location.href.indexOf("swachhteerth/report") != -1
                      ? "active"
                      : ""
                  }
                >
                  <NavLink to="/swachhteerth/report">Report</NavLink>
                </li>
              </ul>
            </li>
            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Har Ghar Vikas</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/hargharvikas/moderation">Moderation</NavLink>
                </li>
                <li>
                  <NavLink to="/hargharvikas/dashboard">Dashboard</NavLink>
                </li>
              </ul>
            </li>
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Sampark Se Samarthan</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/samparksesamarthan/moderation">
                    Moderation
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/samparksesamarthan/dashboard">
                    Dashboard
                  </NavLink>
                </li>
              </ul>
            </li> */}
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Mahila Morcha</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/mahilamorcha/moderation">Moderation</NavLink>
                </li>
                <li>
                  <NavLink to="/mahilamorcha/Gridview">Grid View</NavLink>
                </li>
                <li>
                  <NavLink to="/mahilamorcha/StateWiseCount">
                    State Wise Count
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Motherhood Wall</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/motherhoodwall/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li>
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">My Seva</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                {/* <li><NavLink to="/NMBirthday/add-pledge">Add Pledge</NavLink></li>
                            <li><NavLink to="/NMBirthday/manage-pledge">Manage Pledge</NavLink></li> */}
                <li>
                  <NavLink to="/myseva/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li>
            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Aa Gujarat Main Banaavyu Che</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/gujaratelection/moderation">Moderation</NavLink>
                </li>
                <li>
                  <NavLink to="/gujaratelection/count">Post Count</NavLink>
                </li>
              </ul>
            </li>
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Birthday Seva</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/birthdayseva/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li> */}
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Kamal Pushpa</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                {/* <li><NavLink to="/NMBirthday/add-pledge">Add Pledge</NavLink></li>
                            <li><NavLink to="/NMBirthday/manage-pledge">Manage Pledge</NavLink></li> */}
                <li>
                  <NavLink to="/kamalpushpa/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li>
            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Fit India</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/fit-india/add-videos">Add Videos</NavLink>
                </li>
                <li>
                  <NavLink to="/fit-india/manage-videos">Manage Videos</NavLink>
                </li>
                <li>
                  <NavLink to="/fit-india/moderation">Moderation</NavLink>
                </li>
                <li>
                  <NavLink to="/fit-india/add-social">Add Social Media</NavLink>
                </li>
                <li>
                  <NavLink to="/fit-india/twitter">Twitter Feed</NavLink>
                </li>
              </ul>
            </li>
            <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Sampark Abhiyan</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <NavLink to="/sampark/add-infographics">
                    Add Infographics
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/sampark/manage-infographics">
                    Manage Infographics
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/sampark/moderation">Moderation</NavLink>
                </li>
                <li>
                  <NavLink to="/sampark/userlisting">User Listing</NavLink>
                </li>
                <li>
                  <NavLink to="/sampark/postcount">Posts over time</NavLink>
                </li>
              </ul>
            </li> */}
            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Karnataka</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li>
                  <a href="javascript:void(0);">Moderation</a>
                </li>
              </ul>
            </li> */}
            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">NM Birthday Module</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li><NavLink to="/NMBirthday/add-pledge">Add Pledge</NavLink></li>
                            <li><NavLink to="/NMBirthday/manage-pledge">Manage Pledge</NavLink></li>
                <li>
                  <NavLink to="/NMBirthday/moderation">Moderation</NavLink>
                </li>
                <li>
                  <NavLink to="/NMBirthday/add-social">
                    Add Social Media
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/NMBirthday/twitter">Twitter Feed</NavLink>
                </li>
              </ul>
            </li> */}
            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Mera Booth Sabse Majboot</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li><NavLink to="/NMBirthday/add-pledge">Add Pledge</NavLink></li>
                            <li><NavLink to="/NMBirthday/manage-pledge">Manage Pledge</NavLink></li>
                <li>
                  <NavLink to="/mbsb/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li> */}
            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Mai Bhi Chowkidar</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li><NavLink to="/NMBirthday/add-pledge">Add Pledge</NavLink></li>
                            <li><NavLink to="/NMBirthday/manage-pledge">Manage Pledge</NavLink></li>
                <li>
                  <NavLink to="/maibhiChowkidar/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li> */}
            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Birthday 2019</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li><NavLink to="/NMBirthday/add-pledge">Add Pledge</NavLink></li>
                            <li><NavLink to="/NMBirthday/manage-pledge">Manage Pledge</NavLink></li>
                <li>
                  <NavLink to="/nmbday2019/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li> */}
            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">RB 2020</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li><NavLink to="/NMBirthday/add-pledge">Add Pledge</NavLink></li>
                            <li><NavLink to="/NMBirthday/manage-pledge">Manage Pledge</NavLink></li>
                <li>
                  <NavLink to="/rb2020/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li> */}
            {/* <li>
              <a href="index.html">
                <i className="fa fa-th-large"></i>{" "}
                <span className="nav-label">Birthday 2020</span>{" "}
                <span className="fa arrow"></span>
              </a>
              <ul className="nav nav-second-level collapse">
                <li><NavLink to="/NMBirthday/add-pledge">Add Pledge</NavLink></li>
                            <li><NavLink to="/NMBirthday/manage-pledge">Manage Pledge</NavLink></li>
                <li>
                  <NavLink to="/nmbday2020/moderation">Moderation</NavLink>
                </li>
              </ul>
            </li> */}
            <li>
              <a href="layouts.html">
                <i className="fa fa-diamond"></i>{" "}
                <span className="nav-label">Layouts</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Navigation.jsx